import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, MapPin, Clock, Send } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import { API } from '../config';

export default function Contact() {
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    const form = e.target;
    const data = {
      name: form.elements['contact-name'].value,
      email: form.elements['contact-email'].value,
      subject: form.elements['contact-subject'].value,
      message: form.elements['contact-message'].value,
    };
    try {
      await axios.post(`${API}/contact`, data);
      toast.success('Message sent! We will get back to you within 24 hours.');
      form.reset();
    } catch {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <PageLayout>
      <SEOHead title="Contact Us" description="Reach the Fly N Out team for general inquiries, technical support, or partnership opportunities. We respond within 24 hours, Mon-Fri 9am-6pm AST." url="/contact" keywords="contact fly n out, travel community support, flight community help" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk' }}>Get in Touch</h1>
          <p className="text-muted-foreground">We'd love to hear from you</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <Card className="fly-card p-6">
            <h2 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Space Grotesk' }}>Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
              <div>
                <Label htmlFor="contact-name">Name</Label>
                <Input id="contact-name" name="contact-name" placeholder="Your name" required data-testid="contact-name" />
              </div>
              <div>
                <Label htmlFor="contact-email">Email</Label>
                <Input id="contact-email" name="contact-email" type="email" placeholder="your@email.com" required data-testid="contact-email" />
              </div>
              <div>
                <Label htmlFor="contact-subject">Subject</Label>
                <Input id="contact-subject" name="contact-subject" placeholder="How can we help?" required data-testid="contact-subject" />
              </div>
              <div>
                <Label htmlFor="contact-message">Message</Label>
                <Textarea id="contact-message" name="contact-message" rows={5} placeholder="Tell us more..." required data-testid="contact-message" />
              </div>
              <Button type="submit" className="fly-btn-primary w-full" disabled={sending} data-testid="contact-submit">
                {sending ? 'Sending...' : <>Send Message <Send className="w-4 h-4 ml-2" /></>}
              </Button>
            </form>
          </Card>

          <div className="space-y-4">
            {[
              { icon: Mail, title: 'Email', val: 'info@thesaudigate.com', sub: 'General inquiries' },
              { icon: Mail, title: 'Support', val: 'info@thesaudigate.com', sub: 'Technical support' },
              { icon: MapPin, title: 'Headquarters', val: 'Riyadh, Saudi Arabia', sub: 'KSA registered company' },
              { icon: Clock, title: 'Response Time', val: 'Within 24 hours', sub: 'Mon-Fri, 9am-6pm AST' },
            ].map(({ icon: Icon, title, val, sub }) => (
              <Card key={title} className="fly-card p-4">
                <div className="flex gap-3">
                  <div className="w-9 h-9 rounded-lg bg-[#FF4500]/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-4 h-4 text-[#FF4500]" />
                  </div>
                  <div>
                    <p className="text-sm font-medium">{title}</p>
                    <p className="text-sm text-foreground">{val}</p>
                    <p className="text-xs text-muted-foreground">{sub}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
